import React from "react";
import { useSelector } from "react-redux";

const AuthSeven = () => {
  const locale = useSelector((state) => state.theme.locale);

  return (
    <div
      className="flex-1 flex flex-col items-center justify-center bg-no-repeat bg-cover text-center p-5"
      style={{ backgroundImage: `url('/img/auth/7.jpg')` }}
    >
      <img className="mb-10" alt="Carbon" src="/img/auth/icon4.png" />
      {locale === "en" ? (
        <p className="font-semibold text-[40px] text-white leading-snug">
          Sort quotes from recycling facilities with a single click!
        </p>
      ) : (
        <p className="font-semibold text-[40px] text-white leading-snug">
          Geri dönüşüm tesislerinden <br /> gelen teklifleri tek tuşla sırala!
        </p>
      )}
    </div>
  );
};

export default AuthSeven;
